<template>
  <div>
    <main class="container-fluid"> 
      <section class="row">
        <div class="col-4 px-3 py-3 d-none d-md-flex"></div>
        <div class="col-24 col-md-11 px-md-3 py-md-3 pt-3 pt-md-0 px-3 px-md-0 mb-md-5" >
          <div class="col d-column">
            <h1 class="title pt-2 mb-0" v-text="$ml.get('dashPayTitle')"></h1>
            <h1 class="title">
              <span v-text="$ml.get('dashPaySubTitle')" class="pb-2"></span>
            </h1>
 
            <div class="card mb-3">
              <div class="card-header" v-text="$ml.get('paymentHistory')">Histórico de Pagamentos</div>
 
              <div class='card-search'> 
                <div class="row"> 
                  <div class="col-6 mr-2 py-2">
                      <b-form-datepicker
                        class="datepicker m-0 p-0"
                        label-help=""
                        :date-format-options="{
                          year: 'numeric',
                          month: 'numeric',
                          day: 'numeric',
                        }"
                        :locale="$ml.get('ln')"
                        today-button
                        reset-button
                        close-button
                        :label-today-button="$ml.get('today')"
                        :label-reset-button="$ml.get('reset')"
                        :label-close-button="$ml.get('exit')"
                        v-model="initialDate"
                        :max="maxDate"
                        :placeholder="$ml.get('start')"
                      >
                      </b-form-datepicker>
               
                  </div>

                <div class="col-6 mr-2 py-2">
                    <b-form-datepicker
                      class="datepicker m-0 p-0"
                      label-help=""
                      :date-format-options="{
                        year: 'numeric',
                        month: 'numeric',
                        day: 'numeric',
                      }"
                      :locale="$ml.get('ln')"
                      today-button
                      reset-button
                      close-button
                      :label-today-button="$ml.get('today')"
                      :label-reset-button="$ml.get('reset')"
                      :label-close-button="$ml.get('exit')"
                      :min="initialDate"
                      :max="maxDate"
                      v-model="finalDate"
                      :disabled="initialDate == null"
                      :placeholder="$ml.get('end')"
                    >
                    </b-form-datepicker>
                    <transition name="fade">
                      <label v-if="finalDate && finalDate < initialDate"
                      class="lblError" v-text="$ml.get('warningFinalDate')">A data final deve ser maior que a data inicial.</label>
                    </transition> 
                  </div>

                  <div class="col-10 py-2">
                    <multiselect  
                      v-model="status"
                      label="name" 
                      :custom-label="nameLang"
                      :options="itensSituation" 
                      :searchable="false"
                      :close-on-select="true"
                      :allow-empty="false"
                      :show-labels="false"  
                      :preselect-first="true"
                      @input="changePayment()" 
                      :placeholder="$ml.get('select')"> 
                    </multiselect>  
                  </div>  
                </div>
              </div>
 
              <div class="card-body">

                <div class="loading d-flex ">
                  <div v-if="loading"  class="c-loader"></div>
                  <h6 v-else-if="!listPayments.length" class="col d-flex justify-content-center p-3" v-text="$ml.get('noPaymentsFound')">Nenhum pagamento encontrado</h6>
                </div>
                <div v-for="(item, index) in listPayments" :key="index" class="d-column flex-row pt-3 ">
                  <div :class="'h-profile h-profile-lg d-flex flex-column align-items-center pb-3 '+ (index == listPayments.length -1 ? 'no' : '')" >
                    <div class="d-flex align-self-start">
                      <div class="position-relative align-self-center d-flex align-items-center align-self-center" >
                        <object width="62" height="62" class="rounded-circle img-lg mr-3" :data="item.program_avatar" type="image/png">
                          <img width="62" height="62" class="rounded-circle img-lg mr-3" src="../../../assets/images/default.png" alt="Avatar">
                        </object>
                      </div>
 
                      <div class="pl-2 d-flex">
                        <div class="align-self-start mt-1">
                          <h3 class="pb-1">
                            <a class="link-block" ><strong v-text="item.program_name"></strong></a >
                          </h3>
                          <p class="d-flex align-items-center">
                            <span class="align-self-center" v-text="$ml.with($utils.formatData(item.program_createdAt, $ml.get('ln'))).get('publishedDaysAgo')">Submetido há *</span >
                          </p>
                        </div>
                      </div>
                    </div>

                    <div class="d-flex align-self-start">
                      <div class="v-line d-flex align-items-stretch">
                        <span class="pb-4"></span>
                      </div>
                      <router-link tag="a" :to="'/report/details?'+item.report_id" class='pointer' >
                        <div class="pl-4 d-flex align-items-center pb-3 pt-2">
                          <span :class=" 'badge mr-2 align-self-center '+ (item.report_satus == 'open' ? 'badge-warning' : 'badge-success' )" >#{{item.report_id}}</span >
                            <a class="link-block" v-text="item.report_title"></a >
                        </div>
                      </router-link>
                    </div>

                    <div class="d-flex align-self-start h-profile">
                      <div>
                        <div class="position-relative d-flex align-items-center m-11" > 
                          <object width="42" height="42" class="rounded-circle img-m mr-3" :data="item.payment_author_avatar" type="image/png">
                            <img width="42" height="42" class="rounded-circle img-m mr-3"  src="../../../assets/images/default.png" alt="Avatar">
                          </object>
                          <div class="h-line"><span></span></div> 
                        </div>
                      </div>
                      <div class=" d-flex w-100 align-items-center">
                        <div class="d-flex flex-row justify-content-between align-items-start w-100" >
                          <p>
                            <a class="mr-1" v-text="item.payment_author_name"></a>
                            <font v-text="$ml.get('requestedPayment')">solicitou um pagamento</font>&nbsp;
                            <img src="../../../../src/assets/icons/long-arrow-right.svg" class="ico-15"/>
                            <strong>{{item.company_currency === 'BRL' ? $utils.convertMoney(item.bounty_value) : $utils.convertDollar(item.bounty_value)}}</strong>
                          </p>
                          <p class="time" v-text="$ml.with($utils.formatData(item.payment_createdAt, $ml.get('ln'))).get('ago')">há *</p>
                        </div>
                      </div>
                    </div>

                    <div  class="d-flex align-self-start h-profile">
                      <div class="v-line d-flex align-items-stretch">
                        <span class="pb-4"></span>
                      </div>
                    </div>

                    <div v-if="item.company_bounty_status != 'done'" class="d-flex align-self-start h-profile">
                      <div>
                        <div class="position-relative d-flex align-items-center" >
                          <img src="../../../assets/images/bughunt.png" />
                          <div class="h-line"><span></span></div> 
                        </div>
                      </div>
                      <div class="d-flex w-100 align-items-center">
                        <div class="d-flex flex-row justify-content-between align-items-start w-100" >
                          <p>
                            <a class="mr-1" >bughunt</a >
                            <font v-text="$ml.get('awaitingPayment')">aguardando pagamento</font>&nbsp;
                            <img src="../../../../src/assets/icons/long-arrow-right.svg" class="ico-15"/>
                            <strong>{{$utils.convertMoney(item.bounty_value)}}</strong>
                          </p> 
                        </div>
                      </div>
                    </div>
 
                    <div v-if="item.company_bounty_status == 'done'" class="d-flex align-self-start h-profile">
                      <div>
                        <div class="position-relative d-flex align-items-center" >
                          <img src="../../../assets/images/bughunt.png" />
                          <div class="h-line"><span></span></div> 
                        </div>
                      </div>
                      <div class="d-flex w-100 align-items-center">
                        <div class="d-flex flex-row justify-content-between align-items-start w-100" >
                          <p>
                            <a class="mr-1" >bughunt</a >
                            recebeu o pagamento &nbsp;
                            <img src="../../../../src/assets/icons/long-arrow-right.svg" class="ico-15"/>
                            <strong>{{$utils.convertMoney(item.bounty_value)}}</strong>
                          </p>
                          <p class="time">{{item.payment_date ? ('há '+ $utils.formatData(item.payment_date, $ml.get('ln'))) : ''}}</p>
                        </div>
                      </div>
                    </div>
 
                    <div v-if="item.hacker_bounty_status == 'done'" class="d-flex align-self-start h-profile">
                      <div class="v-line d-flex align-items-stretch">
                        <span class="pb-4"></span>
                      </div>
                    </div>

                    <div v-if="item.hacker_bounty_status == 'done'" class="d-flex align-self-start h-profile-circle">
                      <div class="circle d-flex justify-content-center">
                        <span class="circle-internal d-flex justify-content-center">
                          <span class="circle-success"></span>
                          <div class="h-line h-line-pagto"><span></span></div>
                        </span>
                      </div>
                      <div class="pl-4 d-flex w-100 align-items-center">
                        <div class="d-flex flex-row justify-content-between align-items-start w-100" >
                          <p class="d-flex align-items-center">
                            <a href="" class="mr-1" v-text="$store.getters['getUser'].username"></a >
                            recebeu um pagamento &nbsp;
                            <img src="../../../../src/assets/icons/long-arrow-right.svg" class="ico-15"/>
                            <strong>{{$utils.convertMoney(item.bounty_value)}}</strong>
                          </p>
                          <p class="time" v-text="$ml.with($utils.formatData(item.hacker_bounty_payment_date, $ml.get('ln'))).get('ago')">há *</p>
                        </div>
                      </div>
                    </div> 
 
                  </div>
                </div>
              </div>
              <div v-show="totalPages > 5" class='p-3'> 
                <b-pagination
                  v-model="pageActive"
                  :total-rows="totalPages"
                  :per-page="pageSize" 
                  :prev-text="$ml.get('previous')"
                  :next-text="$ml.get('next')" 
                  align="right">
                </b-pagination> 
              </div>
            </div>
          </div>
        </div>
<!-- Card lado direito -->
        <div class='col-24 col-md-5 pr-md-3 py-md-3 px-3 px-md-0'>
          <section style="height:auto" v-if="rewardsReceivedInReais.length">
            <div class='card mb-3'>
              <div class='card-header card-chart-medium' v-text="$ml.get('rewardsReceivedInReais')">
               Recompensas recebidas em real
              </div>
              <div class='card-body card-chart-body pb-0 pt-1 d-flex flex-column justify-content-left'>
                <div class='row'>
                  <div class='col-12 border-r-d mt-2 mb-2'>
                    <span class='pb-1' v-text="$ml.get('pending')">Pendentes</span>
                     <h6>{{rewardsReceivedInReais[0].pending_amount}}</h6>
                  </div>
                  <div class='col-12 pl-3 mt-2 mb-2'>
                    <span class='pb-1'>Total <font v-text="$ml.get('pending')"></font> </span>
                    <h6>{{$utils.convertMoney(rewardsReceivedInReais[0].pending_total)}}</h6>
                  </div>
                </div>
                <hr class="w-100 m-0" />
                <div class='row'>
                  <div class='col-12 border-r-d mt-2 mb-2'>
                    <span class='pb-1' v-text="$ml.get('done')">Pago</span>
                    <h6>{{rewardsReceivedInReais[0].received_amount}}</h6>
                  </div>
                  <div class='col-12 pl-3 mt-2 mb-2'>
                    <span class='pb-1' >Total <font v-text="$ml.get('done')"></font> </span>
                    <h6>{{$utils.convertMoney(rewardsReceivedInReais[0].received_total)}}</h6>
                  </div>
                </div>
                <hr class="w-100 m-0" />
                <div class='row'>
                  <div class='col-12 border-r-d mt-2 mb-2' style="color: #730BA9;"> 
                    <span class='pb-1' >Total</span>
                    <h6>{{rewardsReceivedInReais[0].general_amount}}</h6>
                  </div>
                  <div class='col-12 pl-3 mt-2 mb-2' style="color: #730BA9;"> 
                    <span class='pb-1' >Total</span>
                    <h6>{{$utils.convertMoney(rewardsReceivedInReais[0].general_total)}}</h6>
                  </div>
                </div>
              </div>
            </div> 
          </section> 
          <section style="height:auto" v-if="rewardsReceivedInDollars.length">
            <div class='card mb-3'>
              <div class='card-header card-chart-medium' v-text="$ml.get('rewardsReceivedInDollars')">
                Recompensas recebidas em dólar
              </div>
              <div class='card-body card-chart-body pb-0 pt-1 d-flex flex-column justify-content-left'>
                <div class='row'>
                  <div class='col-12 border-r-d mt-2 mb-2'>
                    <span class='pb-1' v-text="$ml.get('pending')">Pendentes</span>
                     <h6>{{rewardsReceivedInDollars[0].pending_amount}}</h6>
                  </div>
                  <div class='col-12 pl-3 mt-2 mb-2'>
                    <span class='pb-1'>Total <font v-text="$ml.get('pending')"></font> </span>
                    <h6>{{$utils.convertMoney(rewardsReceivedInDollars[0].pending_total)}}</h6>
                  </div>
                </div>
                <hr class="w-100 m-0" />
                <div class='row'>
                  <div class='col-12 border-r-d mt-2 mb-2'>
                    <span class='pb-1' v-text="$ml.get('done')">Pago</span>
                    <h6>{{rewardsReceivedInDollars[0].received_amount}}</h6>
                  </div>
                  <div class='col-12 pl-3 mt-2 mb-2'>
                    <span class='pb-1' >Total <font v-text="$ml.get('done')"></font> </span>
                    <h6>{{$utils.convertMoney(rewardsReceivedInDollars[0].received_total)}}</h6>
                  </div>
                </div>
                <hr class="w-100 m-0" />
                <div class='row'>
                  <div class='col-12 border-r-d mt-2 mb-2' style="color: #730BA9;"> 
                    <span class='pb-1' >Total</span>
                    <h6>{{rewardsReceivedInDollars[0].general_amount}}</h6>
                  </div>
                  <div class='col-12 pl-3 mt-2 mb-2' style="color: #730BA9;"> 
                    <span class='pb-1' >Total</span>
                    <h6>{{$utils.convertMoney(rewardsReceivedInDollars[0].general_total)}}</h6>
                  </div>
                </div>
              </div>
            </div> 
          </section> 
        </div>

      </section>
    </main>
  </div>
</template>

<script> 
import ReportService from "../../../services/report.service"; 

export default {
  name: "payment", 
  data() {
    return {

      initialDate: '', 
      finalDate: '', 
      maxDate: new Date(),
      status:  { id: 'all' , name: "all"},
    

      itensSituation:[ 
        { id: 'all' , name: "all"}, 
        { id: 'done' , name: "done"},
        { id: 'pending' , name: "pending"}, 
      ], 
   
      pending_total: 0,
      pending_amount: 0,

      received_total: 0,
      received_amount: 0,

      general_amount: 0,
      general_total: 0,

      listPayments: [],
      loading: false,

      pageActive: 1,
      pageSize: 5,
      totalPages: 0,
      listOfRewardsReceived: [],
      rewardsReceivedInReais:[],
      rewardsReceivedInDollars:[],
    };
  },

    watch:{ 
    initialDate: function () { 
        this.dataOrder()
    },
    finalDate: function () { 
        this.dataOrder()
    
    }, 
    pageActive: function () {
      this.changePayment()
    },
  },
  
  mounted() { 
    this.changeSummary();
    this.changePayment();
  },
  methods: {

    nameLang ({ name }) {
      return `${this.$ml.get(name)}`
    },

    dataOrder(){
      var first = this.initialDate;
      var end = this.finalDate; 

      if(this.isValidDate(first) && this.isValidDate(end)){ 
        
        first = first.split('/');
        end = end.split('/');

        first = new Date(first[1] + '-' + first[0] + '-' + first[2]);
        end = new Date(end[1] + '-' + end[0] + '-' + end[2]);

        if (first > end) {
          let invert = this.initialDate;
          this.initialDate = this.finalDate;
          this.finalDate = invert;
        }
        this.changePayment();
      }
      else{
        this.changePayment();
      }

    },

    isValidDate(date){ 
        // eslint-disable-next-line
        var matches = /^(\d{2})[-\/](\d{2})[-\/](\d{4})$/.exec(date);
        if (matches == null) 
        return false;

        var d = matches[1];
        var m = matches[2] - 1;
        var y = matches[3];
        var composedDate = new Date(y, m, d);
        let valid = composedDate.getDate() == d &&
                    composedDate.getMonth() == m &&
                    composedDate.getFullYear() == y;
        return valid; 
    },
 
    changeSummary(){  
      ReportService.getSpecialistPaymentSummary()
      .then(
        (response) => {  
          this.listOfRewardsReceived = response.data;
          this.rewardsReceivedInReais = response.data.filter(it => it.currency === 'BRL')
          this.rewardsReceivedInDollars = response.data.filter(it => it.currency === 'USDT')

          this.pending_total = response.data.pending_total;
          this.pending_amount = response.data.pending_amount;
  
          this.received_total = response.data.received_total
          this.received_amount = response.data.received_amount

          this.general_amount = response.data.general_amount
          this.general_total = response.data.general_total
        }
      );
    },

    changePayment(){  
      this.loading = true;
      this.listPayments = [];

      let payload = ''
 
      payload = ('&status=' + String(this.status.id));

      let initial = this.initialDate;
      if(initial){
        initial = initial.split('/');
        payload += '&initialDate=' + initial;
      }
      let end = this.finalDate;
      if(end){
        end = end.split('/')
        payload += '&finalDate=' + end;
      } 
  
      ReportService.getSpecialistPayment(this.pageActive,5, payload)
      .then(
        (response) => {  
          this.loading = false;
          this.listPayments = response.data.items;
          this.totalPages =  response.data.total; 
        },
        () => {
          this.loading = false;
        }
      );
    } 
  },
};
</script>

<style scoped>
 .m-11 {
   margin-left: 11px !important;
 }
.h-line > span {
    height: 1px ;
    width: 30% !important;
    right: 5px !important;  
}
 
.h-line { 
  width: 10px !important; 
}


.h-line-pagto > span {
  height: 1px ;
    width: 50% !important;
    right: 5px !important;  
}
 
.h-line-pagto { 
  width: 60px !important; 
}
</style>

 
 